import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAnnouncementsLoader } from './useAnnouncementsLoader';
import AnnouncementPopup from './AnnouncementPopup';

export default function AnnouncementsLoader() {
    const { announcements } = useAnnouncementsLoader();
    const { pathname } = useLocation();

    if (/\/announcements/.test(pathname)) return null;

    return <AnnouncementPopup announcements={announcements} />;
}
